import React from 'react';
import {
  StyledForm,
  StyledInput,
  StyledSearchButton,
} from './search-box.style';
import { SearchIcon } from '../../assets/icons/SearchIcon';

// interface Props {
//   onEnter: (e: React.SyntheticEvent) => void;
//   onChange: React.ChangeEventHandler<HTMLInputElement>;
//   value: string;
//   name: string;
//   minimal?: boolean;
//   className?: string;
//   showButtonText?: boolean;
//   shadow?: string;
//   [key: string]: unknown;
// }

export const SearchBox = ({
  onEnter,
  onChange,
  value,
  name,
  minimal,
  buttonText,
  className,
  showButtonText = true,
  shadow,
  ...rest
}) => {
  return (
    <StyledForm
      onSubmit={onEnter}
      className={className}
      boxShadow={shadow}
      minimal={minimal}
    >
      {minimal ? (
        <>
          <SearchIcon style={{ marginLeft: 16, marginRight: 16 }} />
          <StyledInput
            type='search'
            onChange={onChange}
            value={value}
            name={name}
            {...rest}
          />
        </>
      ) : (
        <>
          <StyledInput
            type='search'
            onChange={onChange}
            value={value}
            name={name}
            {...rest}
          />
          <StyledSearchButton>
            <SearchIcon style={{ marginRight: 10 }} />
            {showButtonText && buttonText}
          </StyledSearchButton>
        </>
      )}
    </StyledForm>
  );
};
